import type { Texture } from "pixi.js";
import { SymbolFitMode } from "@slot/presentation";
import type { SymbolDefinition, SymbolDefinitionResolver } from "@slot/presentation";

/**
 * The grid's symbols as the cells draw them: each at its art's own size times one scale, so the nine keep the
 * proportions the artist drew them in (the blue sweet smaller, the FS packet larger), and each moved down its cell by
 * its own offset (none for a symbol without one). No symbol is fitted to its cell (`SymbolFitMode.None`), which would
 * blow the small ones up to the size of the big ones.
 */
export class SymbolCatalog implements SymbolDefinitionResolver {
  private readonly definitions: ReadonlyMap<string, SymbolDefinition>;

  public constructor(input: { textures: ReadonlyMap<string, Texture>; artScale: number; offsetsY: Readonly<Record<string, number>> }) {
    this.definitions = new Map(
      [...input.textures].map(([symbolId, texture]) => [
        symbolId,
        { symbolId, texture, baseScale: input.artScale, fitMode: SymbolFitMode.None, offsetY: input.offsetsY[symbolId] ?? 0, landSoundKey: null },
      ]),
    );
  }

  public resolveDefinition(symbolId: string): SymbolDefinition | null {
    return this.definitions.get(symbolId) ?? null;
  }
}
